export class PatientComplement {
  tl1: boolean;
  dateInstallation?: Date;
  iahInitiale?: number | string;

  constructor(
    tl1: boolean,
    dateInstallation?: Date,
    iahInitiale?: number | string,
  ) {
    this.dateInstallation = dateInstallation;
    this.iahInitiale = iahInitiale;
    this.tl1 = tl1;
  }

  static factory(
    patientComplementAPI: PatientComplementAPI,
  ): PatientComplement {
    return new PatientComplement(
      patientComplementAPI.tl1,
      patientComplementAPI.DateInstallation
        ? new Date(patientComplementAPI.DateInstallation)
        : undefined,
      !isNaN(Number(patientComplementAPI.IahInitiale))
        ? Number(patientComplementAPI.IahInitiale)
        : patientComplementAPI.IahInitiale,
    );
  }
}

export type PatientComplementAPI = {
  tl1: boolean;
  DateInstallation?: string;
  IahInitiale?: string;
  DateEcheance?: string;
  DateDernierePrescription?: string;
};
